import SyosEvents from './utils/SyosEvents';
import SyosPageComponent from './components/SyosPageComponent';
import announce from '../utils/screen-reader/announce';
import type SyosController from './SyosController';
import type SyosCartContainer from './SyosCartContainer';
import { Screen } from './api/types';

class SyosAnnounce {
  constructor(syosController: SyosController) {
    syosController.on(SyosEvents.API_RESERVION_ATTEMPT, this.onReservationAttempt);
    syosController.on(SyosEvents.API_RESERVATION_SUCCESS, this.onReservationSuccess);
    syosController.on(SyosEvents.CART_UPDATE, this.onCartUpdate);
    syosController.on(SyosEvents.SCREEN_UPDATED, this.onScreenUpdated);
    syosController.on(SyosEvents.SEAT_LIST_DATA_LOADED, this.onSeatListDataLoaded);
  }

  onReservationAttempt = () => {
    announce(SyosPageComponent.busyIndicatorReservingSeats);
  };

  onReservationSuccess = () => {
    announce(SyosPageComponent.busyIndicatorReservationSuccessful);
  };

  onCartUpdate = ({ cart }: { cart: SyosCartContainer; }) => {
    // You have 0 seats selected
    // You have 1 seat selected for a subtotal of $111.00
    // You have 2 seats selected for a subtotal of $222.00

    const seatCount = cart.getSeatCount();
    const labelSeats = seatCount === 1 ? 'seat' : 'seats';

    let message = `You have ${seatCount} ${labelSeats} selected`;

    if (seatCount > 0) {
      const subtotalDisplay = cart.getSubtotalDisplay();

      message += ` for a subtotal of ${subtotalDisplay}`;
    }

    announce(message);
  };

  onScreenUpdated = ({ screen }: { screen: Screen }) => {
    if (screen) {
      announce(SyosPageComponent.busyIndicatorLoading);
    }
  };

  onSeatListDataLoaded = () => {
    announce(SyosPageComponent.seatsLoaded);
  };
}

export default SyosAnnounce;
